import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyCostCenter = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        ReadAxios({
            url: 'getCostCenter'
        })
            .then((result) => {
                if(result?.data?.resultSet?.length){
                    setcontent(result.data.resultSet)
                }
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.id
            temp.text = `${object.costCenterName}`
            temp.value = object.costCenterCode
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        if(props.costCenterName){
            let costCenterSelected = options.find((obj)=> obj.value === data.value)
            costCenterSelected && setFieldValue(props.costCenterName, costCenterSelected.text)
        }
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MyCostCenter